var scrolledToolbar = 'fx_c76f37be_bf6bgv2';
var toolbar = 'fx_c76f37be_bf6bgv1';
var toolbarWidth = 'var(--fx_c76f37be_bf6bgv0)';

export { scrolledToolbar, toolbar, toolbarWidth };
//# sourceMappingURL=toolbar.vanilla.mjs.map
